import React from 'react';
import { List } from 'immutable';
import moment from 'moment';

import tr, { translateApartmentType, translateHousingType } from '../../../localization/translate';
import translateFeatureList from '../../../localization/translateFeatureList';
import { Search } from '../../MatchModel';
import DetailsList from '../../../common/DetailsList';

export function rentalType(search) {
  switch (search.rental_type) {
    case 'CONTINUOUS': return tr('property.rental_types.CONTINUOUS');
    case 'FIXED_TERM': return tr('property.rental_types.FIXED_TERM');
    default: return search.rental_type;
  }
}

export function housingTypes(search) {
  return search.housing_types
    .map(translateHousingType)
    .join(tr('matching.features.list.general_separator'));
}

export function roomCount(search) {
  if (search.apartment_types.size === 1) {
    return translateApartmentType(search.apartment_types.get(0));
  }

  return tr('matching.about_search.room_count_range', {
    min: translateApartmentType(search.apartment_types.min()),
    max: translateApartmentType(search.apartment_types.max())
  });
}

export function area(search) {
  if (search.min_size && search.max_size) {
    return tr('matching.about_search.area_range', {
      min: search.min_size,
      max: search.max_size,
      unit: tr('property.AREA_SHORT.METER')
    });
  } if (search.min_size) {
    return tr('matching.about_search.area_only_min', {
      min: search.min_size,
      unit: tr('property.AREA_SHORT.METER')
    });
  } if (search.max_size) {
    return tr('matching.about_search.area_only_max', {
      max: search.max_size,
      unit: tr('property.AREA_SHORT.METER')
    });
  }

  return tr('matching.about_search.area_no_preference');
}

function periodStart(search) {
  return moment.utc().isBefore(search.period_start) ?
    search.period_start.format('l') :
    tr('matching.about_search.period_start_now');
}

function AboutSearchDetails({ search }) {
  const sections = new List([
    {
      title: tr('matching.about_search.starting_date'),
      content: periodStart(search),
      id: 'starting_date'
    },
    {
      title: tr('matching.about_search.rental_type'),
      content: rentalType(search),
      id: 'rental_type'
    },
    {
      title: tr('matching.about_search.housing_type'),
      content: housingTypes(search),
      id: 'housing_type'
    },
    {
      title: tr('matching.about_search.room_count'),
      content: roomCount(search),
      id: 'room_count'
    },
    {
      title: tr('matching.about_search.area'),
      content: area(search),
      id: 'area'
    },
    {
      title: tr('matching.about_search.features'),
      content: translateFeatureList(search.features, true),
      id: 'features'
    }
  ]);

  return <DetailsList mobileLikeOnTwoColumn sections={sections} />;
}

AboutSearchDetails.propTypes = {
  search: Search.propType.isRequired
};

export default AboutSearchDetails;
